import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PageBase, ViewPriceListModel } from 't4core';
import { Router } from '@angular/router';
import { T4DatatableWidget } from '../../../../t4common';

@Component({
  styleUrls: ['./Pricelists.css'],
  selector: 'Pricelists',
  templateUrl: './Pricelists.html',
})
export class Pricelists extends PageBase implements OnInit {
  public isLoading: boolean = false;
  public onlyActive: boolean = true;
  @ViewChild("tblPricelists", { static: false }) tblPricelists: T4DatatableWidget;
  public pricelistsData: ViewPriceListModel[] = [];

  constructor(el: ElementRef, private router: Router) {
    super(el, "TurboOrder");
  }

  async ngOnInit() {
    this.isLoading = true;
    this.pricelistsData = await this.Api.get<ViewPriceListModel[]>("/TurboOrder/GetPricelists");
    this.isLoading = false;
  }

  public gotoPricelist(pricelist: ViewPriceListModel) {
    this.router.navigateByUrl("/TurboOrder/Pricelists/" + pricelist.Id);
  }

  public async GetPricelistsFromAnata() {
    this.isLoading = true;
    var result = await this.Api.get<ViewPriceListModel[]>("/TurboOrder/GetPricelistFromAnata");
    this.isLoading = false;
    if (result) {
      this.pricelistsData = result;
      this.UI.alert("TO.Pricelists.SuccessAnnata", "Pricelists retrieved from Annata", "TO.Pricelists.msgSuccessAnnata", "The latest pricelists are retrieved from Annata.")
    }
    else {
      this.UI.alert("TO.Pricelists.Failed", "Failed!", "TO.Pricelists.msgFailed", "The pricelists could not be retrieved.")
    }
  }

  public async openMappingDialog() {
    console.log("Dialog!");
    var res = await this.UI.openDialog("T4.Order.GroupMappingDialog", { data: this.pricelistsData });

  }

}
